import { useEffect, useState } from 'react';

/**
 * The current time, refreshed every `intervalMs`, so relative labels such as
 * "Last sync 2 h ago" keep advancing while a page stays open (FIG-345 UC-231).
 * Pass `enabled: false` to skip the timer when nothing on screen needs it.
 */
export function useNow(intervalMs = 60_000, enabled = true): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    if (!enabled) return;
    const timer = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs, enabled]);
  return now;
}
